
export type NAME_ITEM_SET = {
    //項目名称No.を取得または設定します。
    ITM_NAME_NO: number;
    //実装を取得または設定します。
    EST: number;
    //項目名称を取得または設定します。
    ITM_NAME: string;
}

//デバイス名称一覧を取得
export const GetNameItemSetList = (): Promise<NAME_ITEM_SET[]> => {
    return new Promise((resolve, reject) => {
      fetch("api/NameItemSet")
      .then((res) => res.json())
        .then((result: NAME_ITEM_SET[]) => {
          console.debug(["api/NameItemSet", result]);
        if (NameItemSetListValidate(result)){
          result.forEach((dev) => {
            //起動判定電流閾値 (%) に変換
            // dev.START_JDG_CUR = dev.RATED_CUR != 0 ? Math.round((dev.START_JDG_CUR / dev.RATED_CUR) * 100) : 0;
          });
          resolve(result);
        }
        else {
          reject('Invalidate response');
        }
      }).catch((error) => {
        console.log(error);
        reject(error);
      })
    });
  };

//グループ一覧取得データ検証
const NameItemSetListValidate = (data: NAME_ITEM_SET[]): boolean => {
    if (data == undefined) {
      console.debug(`GetNameItemSetList NG `);
      return false;
    }
    console.debug(`GetNameItemSetList OK `);
    return true;
  };